import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { DocumentArrowUpIcon } from '@heroicons/react/24/outline';

export default function FileUpload({ onFileSelect, accept = '.pdf,.txt,.json', multiple = false, className = '' }) {
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      if (multiple) {
        onFileSelect(acceptedFiles);
      } else {
        onFileSelect(acceptedFiles[0]);
      }
    }
  }, [onFileSelect, multiple]);

  // Convert accept prop to dropzone format
  const getAcceptObject = (acceptString) => {
    const acceptObj = {};
    if (acceptString.includes('.pdf')) {
      acceptObj['application/pdf'] = ['.pdf'];
    }
    if (acceptString.includes('.txt')) {
      acceptObj['text/plain'] = ['.txt'];
    }
    if (acceptString.includes('.json')) {
      acceptObj['application/json'] = ['.json'];
    }
    if (acceptString.includes('.docx')) {
      acceptObj['application/vnd.openxmlformats-officedocument.wordprocessingml.document'] = ['.docx'];
    }
    if (acceptString.includes('.doc')) {
      acceptObj['application/msword'] = ['.doc'];
    }
    return acceptObj;
  };

  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    onDrop,
    accept: getAcceptObject(accept),
    multiple,
    maxSize: 50 * 1024 * 1024, // 50MB
  });

  return (
    <div className={`w-full ${className}`}>
      <div
        {...getRootProps()}
        className={`border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors ${
          isDragActive
            ? 'border-indigo-400 bg-indigo-50'
            : isDragReject
            ? 'border-red-400 bg-red-50'
            : 'border-gray-300 hover:border-gray-400'
        }`}
      >
        <input {...getInputProps()} />
        <DocumentArrowUpIcon className="w-12 h-12 mx-auto text-gray-400 mb-4" />
        {isDragActive ? (
          <p className="text-indigo-600 font-medium">Drop the file here...</p>
        ) : (
          <div>
            <p className="text-gray-600 font-medium mb-2">
              Drag and drop a file here, or click to select
            </p>
            <p className="text-sm text-gray-500">
              Supports {accept.replace(/\./g, '').replace(/,/g, ', ').toUpperCase()} files (max 50MB)
            </p>
          </div>
        )}
      </div>
    </div>
  );
}